import { useContext } from "react";
import { useRoles, useAuthorizeDomain } from "hooks";
import {
  TEXT_FIELD,
  RADIO_FIELD,
} from "features/assessment/constants/metadataFields";
import { AuditContext } from "../contexts/AuditProvider";
import useExtractMLObservationData from "./useExtractMLObservationData";
import { questionIsAnswered } from "features/protocols/components/Protocols/Preview/helper";

const useResponseMLValidationFlags = ({ q, auditObservation }) => {
  const { audit } = useContext(AuditContext);
  const { isAdmin } = useRoles();
  const { isAuthorizedDomain } = useAuthorizeDomain();
  const { isDone, notesValue } = useExtractMLObservationData(
    auditObservation?.observationId,
  );
  const inapplicable = !!auditObservation?.isInapplicable;
  const aksResponseToggles = q?.machineLearning;
  const aksProtocolToggles = audit?.protocol?.machineLearning;

  const canViewCompliance =
    isDone &&
    isAdmin &&
    notesValue &&
    !inapplicable &&
    isAuthorizedDomain &&
    q.analyzable &&
    q.questionTypeId === TEXT_FIELD &&
    aksProtocolToggles?.hasTopicQualityControl &&
    aksResponseToggles?.hasTopicQualityControl &&
    questionIsAnswered(audit, auditObservation) &&
    auditObservation?.observationId !== "default";

  const canViewConformity =
    isDone &&
    isAdmin &&
    !inapplicable &&
    isAuthorizedDomain &&
    q.prompt.includes("Conformity") &&
    q.questionTypeId === RADIO_FIELD &&
    aksProtocolToggles?.hasConformityQualityControl &&
    aksResponseToggles?.hasConformityQualityControl &&
    questionIsAnswered(audit, auditObservation) &&
    auditObservation?.observationId !== "default";

  const canViewAutoResponses = aksProtocolToggles?.hasAutoResponses;

  return {
    canViewCompliance,
    canViewConformity,
    aksProtocolToggles,
    aksResponseToggles,
    canViewAutoResponses,
  };
};

export default useResponseMLValidationFlags;
